import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/AppShell";
import { useIsAudraIdAdmin, useMe } from "@/api/me";

import { AppsPage } from "@/pages/Apps";
import { AuditPage } from "@/pages/Audit";
import { GroupsPage } from "@/pages/Groups";
import { LoginPage } from "@/pages/Login";
import { UsersPage } from "@/pages/Users";

export default function App() {
  const { data: me, isLoading, isError } = useMe();
  const isAdmin = useIsAudraIdAdmin();

  // The /login route is the ONLY public entry point — everything else 401s
  // if there's no session, which the axios interceptor catches and converts
  // into an SSO redirect.
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-wm-gray-100/60">
        Loading…
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          isError || !me ? (
            <Navigate to="/login" replace />
          ) : !isAdmin ? (
            <DeniedPage email={me.user.email} />
          ) : (
            <AppShell>
              <Routes>
                <Route path="/" element={<Navigate to="/users" replace />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/groups" element={<GroupsPage />} />
                <Route path="/apps" element={<AppsPage />} />
                <Route path="/audit" element={<AuditPage />} />
              </Routes>
            </AppShell>
          )
        }
      />
    </Routes>
  );
}

function DeniedPage({ email }: { email: string }) {
  return (
    <div className="mx-auto mt-24 max-w-md text-center">
      <h1 className="font-display text-2xl text-wm-white">Not authorised</h1>
      <p className="mt-3 text-sm text-wm-gray-100/70">
        You're signed in as <code className="text-wm-purple-bright">{email}</code>, but you don't have
        the Windmill ID admin role yet. Ask a Windmill ID admin to grant it, then refresh.
      </p>
    </div>
  );
}
